// extracted by mini-css-extract-plugin
export default {"galryimage":"ServiceProject_galryimage__kJZ+M","btnmore":"ServiceProject_btnmore__9cSKJ","more":"ServiceProject_more__FBZI3"};